<template>
  <div
    :class="['collectionController', { isActive: isActive }]"
    @mouseenter="showController"
    @mouseleave="hideController">
    <div class="collectionControllerBg"></div>

    <div class="collectionControllerInner">
      <button type="button" class="btn btnWhite btnRound sizeXs" @click="searchMode">
        검색모드
        <span>{{ isSearchMode ? 'OFF' : 'ON'}}</span>
      </button>
      <button type="button" class="btn btnWhite btnRound sizeXs" @click="fullScreen">
        전체화면
        <span>{{ isFullScreen ? 'OFF' : 'ON'}}</span>
      </button>
      <!-- <button v-if="isMyCollection" type="button" class="btn btnWhite btnRound sizeXs" @click="getSnapshot">
        마이콜렉션
        <span>내역</span>
      </button>
      <button v-if="isMyCollection" type="button" class="btn btnRound sizeXs" @click="saveSnapshot">
        마이콜렉션
        <span>저장</span>
      </button> -->
    </div>

    <MyCollectionSnapshot
      v-if="isSnapshot"
      :locale="locale"
      :lang="lang"
      :list="snapShotList"
      @close="closeSnapshot" />
  </div>
</template>

<script>
import MyCollectionSnapshot from './MyCollectionSnapshot'

export default {
  name: 'CollectionController',
  props: [
    'locale',
    'lang',
    'isFullScreen',
    'isSearchMode',
    'isMyCollection'
  ],
  components: {
    MyCollectionSnapshot
  },
  beforeDestroy () {
    if (this.hideTimer) clearTimeout(this.hideTimer)
  },
  data () {
    return {
      isActive: false,
      hideTimer: null,
      isSnapshot: false,
      snapShotList: []
    }
  },
  methods: {
    fullScreen () {
      this.$emit('fullScreen')
    },
    searchMode () {
      this.$emit('searchMode')
    },
    async getSnapshot () {
      try {
        const pageId = this.$route.params.pageId
        const res = await this.$store.dispatch('collection/getMyCollectionSnapshot', pageId)
        if (res && res.snapShotList) {
          if (!res.snapShotList.length) {
            alert ('저장된 마이콜렉션 내역이 없습니다.')
            return
          }
          this.isSnapshot = true
          this.snapShotList = res.snapShotList.sort((a, b) => new Date(b.createat) - new Date(a.createat))
        }
      } catch (err) {
        alert(err)
      }
    },
    async saveSnapshot () {
      try {
        const data = {
          pageId: this.$route.params.pageId
        }
        const res = await this.$store.dispatch('collection/saveMyCollectionSnapshot', data)
        if (res && res.message && res.message.snapShotVersion) {
          
        }

      } catch (err) {
        alert(err)
      }
    },
    closeSnapshot () {
      this.isSnapshot = false
    },
    showController () {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer)
        this.hideTimer = null
      }
      this.isActive = true
    },
    hideController () {
      if (this.hideTimer) clearTimeout(this.hideTimer)

      this.hideTimer = setTimeout(() => {
        this.isActive = false
      }, 120)
    }
  }
}
</script>